import React, { createContext, useState, useContext, useEffect } from "react";
import { useCart } from "../context/CartContect";

// Create the context
const OrderContext = createContext();

// Provider component
export const OrderProvider = ({ children }) => {
  const { cart } = useCart();
  const [order, setOrder] = useState({
    items: cart,
    totalAmount: 0, // Total order amount
    totalAmountToChargeFromCard: 0,
    deliveryCost: 0, // Delivery cost
    amountFromWallet: 0,
    address: null, // Selected address
    couponCode: null, // Applied coupon code,
    couponDiscount: 0,
    
    couponCashback: 0,
    restaurant: null,
    method: "stripe",
    dealDiscount: 0,
    deal: null,
  });

  useEffect(() => {
    const newTotalAmount = calculatePrice();
    console.log("New Total Amount:", newTotalAmount);
    let totalAmountToChargeFromCardAmount = calculatePrice(true);
    totalAmountToChargeFromCardAmount = parseFloat(totalAmountToChargeFromCardAmount).toFixed(2);

    const dealDiscount =
  order.deal ? newTotalAmount * (order.deal.deal_value / 100) : 0;

    setOrder((prevOrder) => ({ ...prevOrder, items: cart }));
    applyDeal(order.deal, dealDiscount  );
    setOrder((prevOrder) => ({ ...prevOrder, totalAmount: newTotalAmount - order.couponDiscount-dealDiscount,
         totalAmountToChargeFromCard:totalAmountToChargeFromCardAmount }));
  }, [cart, order.deliveryCost, order.amountFromWallet]);

  const calculatePrice = (isCalculatingtotalAmountToChargeFromCard) => {
    let price = 0;
    price =
      price +
      cart?.reduce(
        (total, item) => total + item.quantity * (item.product.price+item.option.reduce((optTotal, opt) => optTotal + (opt.price || 0), 0) ),
        0
      );
    price = price + order.deliveryCost;
    if (isCalculatingtotalAmountToChargeFromCard) {
      if (order.amountFromWallet - price <= 0) {
        return price - order.amountFromWallet;
      } else {
        return 0;
      }
    }

    return price;
  };

  const setrestaurant = (restaurant) => {
    console.log("Setting up Restaurant", restaurant);
    setOrder((prevOrder) => ({ ...prevOrder, restaurant: restaurant }));
  };
  const setDeliveryAddress = (address) => {
    setOrder((prevOrder) => ({ ...prevOrder, address }));
  };
  const setDeliveryCost = (deliveryCost) => {
    setOrder((prevOrder) => ({ ...prevOrder, deliveryCost }));
  };

  const setWalletAmount = (amountFromWallet) => {
    setOrder((prevOrder) => ({ ...prevOrder, amountFromWallet }));
  };
  const setPaymentType = (method) => {
    setOrder((prevOrder) => ({ ...prevOrder, method }));
  };

  const setDeal = (deal) => {
    console.log("Setting deal", deal);
    setOrder((prevOrder) => ({ ...prevOrder, deal: deal }));
  };

  const applyCoupon = (couponCode, discountAmount,cashbackAmount) => {
    setOrder((prevOrder) => ({
      ...prevOrder,
      couponCode,
      totalAmount: prevOrder.totalAmount - discountAmount -0,
      couponDiscount: discountAmount,
      couponCashback: cashbackAmount, 
    }));
  };
  const applyDeal = (deal, dealDiscount) => {
    console.log("Applying deal", deal, dealDiscount);
    setOrder((prevOrder) => ({
      ...prevOrder,
      deal:deal,
      dealDiscount:dealDiscount,
      couponCode: null, 
      couponDiscount: 0,
      couponCashback: 0,
      
      
    }));
  };

  // Clear the order
  const clearOrder = () => {
    setOrder({
      items: [],
      totalAmount: 0,
      deliveryCost: 0,
      amountFromWallet: 0,
      address: null,
      couponCode: null,
      deal: null,
    });
  };

  return (
    <OrderContext.Provider
      value={{
        order,
        setDeliveryAddress,
        applyCoupon,
        clearOrder,
        calculatePrice,
        setrestaurant,
        setDeliveryCost,
        setWalletAmount,
        setPaymentType,
        setDeal,
        applyDeal,
      }}>
      {children}
    </OrderContext.Provider>
  );
};

// Custom hook for accessing the context
export const usePlaceOrder = () => {
  return useContext(OrderContext);
};
